<script>
import { useAlert } from 'dashboard/composables';
import { mapActions } from 'vuex';
import WeeklyHoursEditor from '../components/WeeklyHoursEditor.vue';
import { apiErrorMessage } from '../../../../api/realEstate/errors';
import { toHourRows } from '../helpers';

// Thin wrapper around WeeklyHoursEditor — Date overrides (Layer 0 special
// dates) live in BookingSection.vue instead, since they're their own list
// with their own add/delete flow (docs/real-estate/be/
// 10-api-reference.md §A7).
export default {
  name: 'OpeningHoursModal',
  components: { WeeklyHoursEditor },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hours: toHourRows(this.project.showroom.opening_hours),
      isSubmitting: false,
    };
  },
  methods: {
    ...mapActions('realEstate', ['saveOperatingHours']),
    async handleSubmit() {
      if (!this.$refs.hoursEditor.isValid()) {
        useAlert(this.$t('REAL_ESTATE.ERRORS.INVALID_TIME_RANGE'));
        return;
      }
      this.isSubmitting = true;
      try {
        await this.saveOperatingHours({
          propertyId: this.project.property_id,
          hours: this.hours,
        });
        useAlert(this.$t('REAL_ESTATE.OPENING_HOURS.SUCCESS_UPDATED'));
        this.$emit('close');
      } catch (err) {
        useAlert(
          apiErrorMessage(this, err, 'REAL_ESTATE.OPENING_HOURS.ERROR_UPDATE')
        );
        // eslint-disable-next-line no-console
        console.error(err);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<template>
  <div
    class="fixed inset-0 flex items-center justify-center bg-slate-800/80 z-50"
  >
    <div
      class="bg-white dark:bg-slate-900 rounded-lg p-6 shadow-lg w-full max-w-xl max-h-[85vh] overflow-y-auto"
    >
      <div class="flex items-center mb-4 justify-between">
        <h1 class="text-xl font-bold text-slate-900 dark:text-slate-100">
          {{ $t('REAL_ESTATE.OPENING_HOURS.MODAL_TITLE') }}
        </h1>
        <woot-button
          variant="clear"
          color-scheme="alert"
          icon="dismiss"
          @click="$emit('close')"
        />
      </div>

      <form class="space-y-3" @submit.prevent="handleSubmit">
        <WeeklyHoursEditor ref="hoursEditor" v-model="hours" />

        <div
          class="flex justify-end gap-3 pt-4 mt-2 border-t border-slate-200 dark:border-slate-700"
        >
          <woot-button variant="clear" type="button" @click="$emit('close')">
            {{ $t('REAL_ESTATE.OPENING_HOURS.CANCEL') }}
          </woot-button>
          <woot-button type="submit" :is-loading="isSubmitting">
            {{ $t('REAL_ESTATE.OPENING_HOURS.SAVE') }}
          </woot-button>
        </div>
      </form>
    </div>
  </div>
</template>
